__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "otms-odyssey-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@angular/animations/browser", "17.2.0", () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(655))))));
			register("@angular/animations", "17.2.0", () => (__webpack_require__.e(172).then(() => (() => (__webpack_require__(7172))))));
			register("@angular/common/http", "17.3.12", () => (__webpack_require__.e(443).then(() => (() => (__webpack_require__(6443))))));
			register("@angular/common", "17.2.0", () => (__webpack_require__.e(935).then(() => (() => (__webpack_require__(316))))));
			register("@angular/core/primitives/signals", "17.2.0", () => (__webpack_require__.e(689).then(() => (() => (__webpack_require__(5689))))));
			register("@angular/core", "17.2.0", () => (__webpack_require__.e(580).then(() => (() => (__webpack_require__(7580))))));
			register("@angular/forms", "17.2.0", () => (__webpack_require__.e(75).then(() => (() => (__webpack_require__(4456))))));
			register("@angular/platform-browser/animations", "17.2.0", () => (__webpack_require__.e(216).then(() => (() => (__webpack_require__(3835))))));
			register("@angular/platform-browser", "17.2.0", () => (__webpack_require__.e(436).then(() => (() => (__webpack_require__(436))))));
			register("@angular/router", "17.2.0", () => (__webpack_require__.e(691).then(() => (() => (__webpack_require__(5072))))));
			register("aws-amplify", "6.0.0", () => (__webpack_require__.e(214).then(() => (() => (__webpack_require__(9833))))));
			register("rxjs/operators", "7.8.0", () => (__webpack_require__.e(620).then(() => (() => (__webpack_require__(3620))))));
			register("rxjs", "7.8.0", () => (__webpack_require__.e(340).then(() => (() => (__webpack_require__(1340))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};